import React from "react";
import PropTypes from "prop-types";
import styles from "./ConfirmationDialog.module.css";
import classNames from "classnames";

/**
 * Interactive component. Dialog that prompts the user for confirmation.
 */
export function ConfirmationDialog({
  onConfirmation,
  onDismiss,
  confirmationText,
  isVisible,
}) {
  return (
    <>
      <div
        className={classNames(styles.blur, {
          [styles.hidden]: !isVisible,
        })}
      >
        <div className={styles.container}>
          <div className={styles.text}>{confirmationText}</div>
          <div className={styles["button-container"]}>
            <button
              type="button"
              className={styles.positive}
              onClick={onConfirmation}
            >
              Yes
            </button>
            <button
              type="button"
              className={styles.negative}
              onClick={onDismiss}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

ConfirmationDialog.propTypes = {
  /**
   * Function that fires when the positive button is clicked.
   */
  onConfirmation: PropTypes.func,
  /**
   * Function that fires when the negative button is clicked.
   */
  onDismiss: PropTypes.func,
  /**
   * String that prompts the user for confirmation.
   */
  confirmationText: PropTypes.string,
  /**
   * Boolean that determines if the dialog is open.
   */
  isVisible: PropTypes.bool,
};
